export default __webpack_public_path__ + "static/char-s-31-ko-fcb0e8013cf39e7ba1726fc893eb0475.webp";